import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 20l6 -6l3 -3l1.5 -1.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4h4","key":"svg-0"}],["path",{"d":"M13.5 6.5l4 4","key":"svg-1"}],["path",{"d":"M19 22v.01","key":"svg-2"}],["path",{"d":"M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483","key":"svg-3"}]]

const IconPencilQuestion = createReactComponent('outline', 'pencil-question', 'PencilQuestion', __iconNode);

export default IconPencilQuestion;